import { useState } from "react";
import { ContadorInputCard } from "./components/ContadorInpuCard";
import { ContadorResponse } from "./components/ContadorResponse";
import { ContadorDiasResponse } from "./Contador-dias";

export default function ContadorDiasUteis() {
  const [results, setResults] = useState<ContadorDiasResponse | null>(null);
  return (
    <>
      <ContadorInputCard setResults={setResults} />
      {results && <ContadorResponse results={results} />}
    </>
  );
}